var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDonutChartLine = function SvgDonutChartLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.6 3.045v1.81a7.201 7.201 0 1 0 5.315 12.833l1.281 1.28A9 9 0 1 1 11.6 3.044Zm9.855 9.855a8.95 8.95 0 0 1-1.986 4.795l-1.281-1.28a7.17 7.17 0 0 0 1.456-3.515h1.812zm-8.053-9.855a9 9 0 0 1 8.055 8.055h-1.812a7.204 7.204 0 0 0-6.243-6.244z"
  })));
};
export default SvgDonutChartLine;